import { put, select } from 'redux-saga/effects';
import { selectFormById } from './formControlSelectors';
import { formControlActions } from './formControlSlice';
import store from '../store';
import { notificationHandler } from 'utils/utils';
import { homeActions } from 'store/homePageSlice/homePageSlice';
import { axiosSSO } from 'config';

export function* roleMenagmentFormSaga({ payload: type }) {
    try {
        const formId = type.formId;
        const {
            form: { values, errors },
        } = yield select(selectFormById(formId));
        let isFormValid = true;

        Object.keys(errors).forEach((fieldName) => {
            if (errors[fieldName]) {
                isFormValid = false;
                store.dispatch(formControlActions.setFieldTouched({ formId, fieldName }));
            }
        });

        if (!isFormValid) {
            yield notificationHandler({
                title: 'Please fill required fields',
                variant: 'warning',
            });
            return;
        }

        if (type.formStatus === 'add') {
            const response = yield axiosSSO.post(type.postUrl, values);

            if (response.data.code === 'SUCCESS') {
                yield put(homeActions.fetchRolesStart());

                yield notificationHandler({
                    title: `SUCCESSFULLY ADDED ROLE`,
                    variant: 'success',
                });
            }
        }
    } catch (err) {
        if (err.response?.status === 404) {
            yield notificationHandler({ title: 'That role already exist!' });
        } else {
            yield notificationHandler({ title: 'Error adding role!' });
        }

        yield put(formControlActions.submitFormFailed(JSON.stringify(err.message)));
    }
}
